import { render, staticRenderFns } from "./ContactInformationRelatedContact.vue?vue&type=template&id=163f1f82&scoped=true&"
import script from "./ContactInformationRelatedContact.vue?vue&type=script&lang=ts&"
export * from "./ContactInformationRelatedContact.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInformationRelatedContact.vue?vue&type=style&index=0&id=163f1f82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f1f82",
  null
  
)

export default component.exports